import { render } from "./SettingsMain.vue?vue&type=template&id=2097b25e&scoped=true"
import script from "./SettingsMain.vue?vue&type=script&lang=js"
export * from "./SettingsMain.vue?vue&type=script&lang=js"

import "./SettingsMain.vue?vue&type=style&index=0&id=2097b25e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2097b25e"]])

export default __exports__